module.exports = "pegasus/assets/square-google.png";